module.exports = ".header{\r\n    text-align: center;\r\n}\r\n\r\n.container {\r\n    width: 100%;\r\n  }\r\n\r\n.odd {\r\n      color: red;\r\n  }\r\n\r\n.even {\r\n    color: green;\r\n}\r\n\r\na{\r\n    color: initial;\r\n    text-decoration: underline;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/directives/directives.component.css
// module id = ./src/app/components/directives/directives.component.css
// module chunks = main